class ItemIcons extends React.Component {
    render(icon = this.props.icon) {

        if (icon === 'user') {
            return (
                <React.Fragment>
                     <span className="big-auction-block-user" title={LANG['Kasutaja poolt lisatud oksjon'] || 'Kasutaja poolt lisatud oksjon'}>
                             <i className="fas fa-user" aria-hidden="true"></i>
                     </span>
                </React.Fragment>
            )
        } else if (icon === "maaportaal") {
            return (
                <React.Fragment>
                    <span className="big-auction-block-user" title={LANG['Maaporaali poolt lisatud oksjon'] || 'Maaporaali poolt lisatud oksjon'}>
                        <img className="auction-by-metsaoksjon" src={'/images/brands/logo-colored.svg' } alt="auction-by-metsaoksjon"/>
                     </span>
                </React.Fragment>
            )
        } else if (icon === "kv24" || icon === "city24" || icon === "soov"){
            return (
                <React.Fragment>
                    <span className="big-auction-block-other nowrap grid-x" title={`${icon}.ee ${LANG['kuulutus'] || 'kuulutus'}`}>
                    {icon === "kv24" ?
                        <img className="kv24-icon" src={'/images/brands/logo-kv24.svg' } alt="auction-by-metsaoksjon"/> : ''
                    }
                    {icon === "city24" ?
                        <img className="city24-icon" src={'/images/brands/logo-city24.svg' } alt="auction-by-metsaoksjon"/> : ''
                    }
                    {icon === "soov" ?
                        <img className="soov" src={'/images/brands/logo-soov.svg' } alt="auction-by-metsaoksjon"/> : ''
                    }
                        <i className={icon === "city24" ? "fas fa-external-link-alt city24-icon":"" + icon === "kv24" ? "fas fa-external-link-alt  kv24-icon" : "" + icon === "soov" ? "fas fa-external-link-alt  soov-icon" : ""}></i>
                    </span>
                </React.Fragment>
            )
        }else {
            return (
                <React.Fragment>

                </React.Fragment>
            )
        }
    }
}

export default ItemIcons;

